import React from 'react';

const SelectBox = ({ options, value, onChange, className = '', disabled, name, ...props }) => {
    return (
        <select
            className={className}
            value={value}
            onChange={onChange}
            disabled={disabled}
            name={name}
            {...props}
        >
            {options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default SelectBox;